import { useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";

const LINKS = [
  { label: "Hjem", href: "#hjem" },
  { label: "Services", href: "#services" },
  { label: "Cases", href: "#cases" },
  { label: "Priser", href: "#priser" },
  { label: "Om os", href: "#om-os" },
];

export const Navigation = ({ onNavigate }) => {
  const [open, setOpen] = useState(false);

  const go = (href) => (e) => {
    e.preventDefault();
    setOpen(false);
    onNavigate(href);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-zinc-200/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
        <a
          href="#hjem"
          onClick={go("#hjem")}
          data-testid="nav-logo"
          className="flex items-center gap-2.5 font-bold text-lg tracking-tight text-zinc-900"
        >
          <span className="w-3.5 h-3.5 bg-zinc-900 rounded-[4px]" aria-hidden="true" />
          Naveli
        </a>

        <nav className="hidden md:flex items-center gap-8" aria-label="Hovedmenu">
          {LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={go(link.href)}
              data-testid={`nav-link-${link.href.replace("#", "")}`}
              className="text-sm font-medium text-zinc-600 hover:text-zinc-900 transition-colors duration-200"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#kontakt"
            onClick={go("#kontakt")}
            data-testid="nav-cta-button"
            className="hidden sm:inline-flex items-center gap-2 bg-zinc-900 text-white text-sm font-medium rounded-full px-5 py-2.5 hover:bg-zinc-700 hover:-translate-y-px transition-all duration-200"
          >
            Få et gratis forslag
            <ArrowRight className="w-4 h-4" aria-hidden="true" />
          </a>
          <button
            type="button"
            data-testid="mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="md:hidden p-2 text-zinc-900"
            aria-label={open ? "Luk menu" : "Åbn menu"}
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          className="md:hidden border-t border-zinc-200/80 bg-white/95 backdrop-blur-md px-4 py-4 space-y-1"
          aria-label="Mobilmenu"
          data-testid="mobile-menu"
        >
          {LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={go(link.href)}
              data-testid={`mobile-nav-link-${link.href.replace("#", "")}`}
              className="block px-3 py-2.5 text-base font-medium text-zinc-700 hover:text-zinc-900 rounded-lg hover:bg-zinc-100 transition-colors duration-200"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#kontakt"
            onClick={go("#kontakt")}
            data-testid="mobile-nav-cta-button"
            className="flex items-center justify-center gap-2 mt-2 bg-zinc-900 text-white text-sm font-medium rounded-full px-5 py-3"
          >
            Få et gratis forslag
            <ArrowRight className="w-4 h-4" aria-hidden="true" />
          </a>
        </nav>
      )}
    </header>
  );
};
